import { render, staticRenderFns } from "./AssessmentIntroduction.vue?vue&type=template&id=1f30e5b4"
import script from "./AssessmentIntroduction.vue?vue&type=script&lang=js"
export * from "./AssessmentIntroduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports